import {
    Box,
    Heading,
    HStack,
    IconButton,
    Stack,
    useToast,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { useImportWatchListMutation, useListTicketsQuery } from '../../api'
import { watchListColumns } from './Columns'
import { ConfirmModal } from './ConfirmModal'

import { ReloadIcon } from '@/assets/icon'
import { FetchingIndicator, DataTable } from '@/components/Elements'
import { getUserId } from '@/features/auth'

// see: https://redux-toolkit.js.org/rtk-query/usage/mutations#shared-mutation-results
export const useSyncTickets = () => {
    return useImportWatchListMutation({
        fixedCacheKey: 'shared-sync-tickets',
    })
}

export const WatchList = () => {
    const [query] = useState(() => ({
        sort: 'distributedAt',
        direction: 'desc',
        userId: getUserId(),
        status: 'uncompleted',
        type: 'auto',
    }))
    const [initialState] = useState(() => ({
        sortBy: [{ id: query.sort, desc: query.direction === 'desc' }],
    }))
    const { data, isFetching } = useListTicketsQuery(query)

    const [importData, { isLoading }] = useSyncTickets()
    const toast = useToast()
    return (
        <FetchingIndicator as={Stack} isFetching={isFetching || isLoading}>
            <HStack>
                <Heading>交渉中候補者</Heading>
                <Box>
                    <IconButton
                        variant="gradient"
                        size="xs"
                        aria-label="refresh"
                        icon={<ReloadIcon boxSize="1rem" />}
                        isLoading={isLoading}
                        onClick={() => {
                            importData({ userId: getUserId() })
                                .unwrap()
                                .then(({ items }) => {
                                    const message =
                                        items.length > 0
                                            ? `${items.length}名の候補者が追加されました`
                                            : 'リストは最新の状態です'
                                    toast({
                                        title: message,
                                        status: 'success',
                                    })
                                })
                        }}
                    />
                </Box>
            </HStack>
            {/* 一覧 */}
            {data && <Table initialState={initialState} items={data.items} />}
            {/* 求職者変更確認 */}
            <ConfirmModal />
        </FetchingIndicator>
    )
}

const Table = ({ items, initialState }) => {
    const state = DataTable.useReactTable({
        data: items,
        columns: watchListColumns,
        initialState,
    })
    return (
        <DataTable.Provider {...state}>
            <DataTable.Table
                sx={{
                    counterReset: 'row-number',
                }}
            >
                <DataTable.Head />
                <DataTable.Body />
            </DataTable.Table>
        </DataTable.Provider>
    )
}
Table.propTypes = {
    initialState: PropTypes.any.isRequired,
    items: PropTypes.array.isRequired,
}
